module.exports = __webpack_public_path__ + "static/media/checkoutbg_center_normal.afcec7a4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/checkout-navbar/progress-bullet/checkoutbg_center_normal.svg
// module id = 695
// module chunks = 0